import { Store } from '../../../app/services/api/generated';

export const ALL_STORES_TOKEN = '__ALL_STORES__';

export type StoreOption = {
  storeName: string;
  storeNumber: string;
  isAll?: boolean;
  _numKey?: number;
};

export type StoreSelection =
  | { mode: 'all' }
  | { mode: 'specific'; storeNumbers: string[] };

export interface MultiStorePickerProps {
  /** Array of stores from user context or API */
  stores: Store[];
  /** Current selection state */
  value: StoreSelection;
  /** Callback when selection changes */
  onChange: (selection: StoreSelection) => void;
  /** Label for "All Stores" option - pass translated string. Not required when hideAllStoresOption is set. */
  allStoresLabel?: string;
  /** Label for the input field */
  label?: string;
  /** Placeholder text for search */
  placeholder?: string;
  /** Whether the picker is disabled */
  disabled?: boolean;
  /** Size of the component */
  size?: 'small' | 'medium';
  /** Hide the "All Stores" pseudo-option, e.g. when bulk/all-store scoping isn't supported */
  hideAllStoresOption?: boolean;
  /** Cap the number of specific stores that can be selected. When exceeded, only the most recently picked stores are kept (set to 1 for single-store selection). */
  maxSelections?: number;
}
